import React, { useState, useEffect } from "react";
import PageTitle from "../components/PageTitle";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import MainWrapper from "../layouts/MainWrapper";
import CardWrapper from "../layouts/CardWrapper";
import DataTable from "../components/Table/Table";
import ExpertiseDetailsPanel from "../components/DetailsPanel/ExpertiseDetailsPanel";
import TablePagination from "../components/TablePagination/TablePagination";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import { expertiseList, deleteExpertise } from "../services/expertiseService";
import { listExpertUsers } from "../services/userService";
import { useAlert } from "../contexts/AlertContext";
import ImagePreviewLightbox from "../components/ImagePreviewLightbox";
import useDebounce from "../utils/useDebounce";

const Routing = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [expertiseListData, setExpertiseListData] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [expertUsers, setExpertUsers] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [subExpertiseToShow, setSubExpertiseToShow] = useState(2);
  const [selectedPage, setSelectedPage] = useState(1);
  const { showAlert } = useAlert();
  const [filter, setFilter] = useState({
    no_of_result: 10,
    page: 1,
    search: "",
  });
  const [searchFlag, setSearchFlag] = useState(false);
  const debouncedSearchTerm = useDebounce(filter, searchFlag ? 500 : 0);

  const columns = [
    { label: "Main Expertise", key: "main_xpertise" },
    { label: "Sub Expertise", key: "sub_xpertise" },
    { label: "Assigned Experts", key: "assigned_experts" },
  ];

  const rowHandler = (row) => {
    setSelectedItem(row);
    document.body.classList.add("sidebar-collapsed");
  };

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    filter[name] = value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  function extractUrls(data) {
    const result = [];
    const resultIds = [];

    function recurse(item) {
      if (Array.isArray(item?.expertiseAssign)) {
        console.log("USER PROFILE FUND IN", item?.expertiseAssign)
        item?.expertiseAssign?.forEach((assign) => {
          if (assign.user?.id && !resultIds.includes(assign.user?.id)) {
            console.log("USER PROFILE FUND", assign)
            const url =
              assign.user?.profilePic?.trim() || assign?.profilePic?.trim();
            result.push(url ? url : "/images/user-circle.svg");
            resultIds.push(assign.user?.id);
          }
        });
      }

      if (Array.isArray(item?.children)) {
        item.children.forEach((child) => recurse(child));
      }
    }

    recurse(data);
    console.log("resultIds", resultIds);
    return result;
  }

  const deleteExpertiseFunc = async (id) => {
    try {
      const singleExpertiseData = await deleteExpertise(id);
      showAlert({
        title: "Routing Notification",
        message: singleExpertiseData?.message ?? "something went wrong",
        variant: "success",
      });
      console.log("delete message", singleExpertiseData);
      fetchExpertise();
      setShowModal(null);
      setSelectedItem(null);
    } catch (error) {
      console.error("Error saving user:", error);
      setShowModal(null);
      setSelectedItem(null);
      showAlert({
        title: "Routing Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const appendExpertiseList = (expertiseToAdd) => {
    if (!expertiseToAdd) return;

    const newExpertiseToAdd = {
      ...expertiseToAdd,
      assignedUserImages: extractUrls(expertiseToAdd),
    };

    const expertiseListDataCopy = [...expertiseListData];

    const index = expertiseListDataCopy.findIndex(
      (item) => item?.id === newExpertiseToAdd?.id
    );

    let updatedList;

    if (index !== -1) {
      // Replace existing element
      updatedList = expertiseListDataCopy.map((item, i) =>
        i === index ? { ...newExpertiseToAdd } : item
      );
    } else {
      updatedList = [newExpertiseToAdd, ...expertiseListDataCopy];
      if (updatedList.length > 10) {
        updatedList.pop();
      }
      setTotalResults(totalResults + 1)
    }

    setExpertiseListData((prev) => [...updatedList]);
    setSelectedItem((prev) => { return { ...newExpertiseToAdd } });

    console.log("queued update with:", newExpertiseToAdd, expertiseToAdd);
  };
  const changeFilterCriteria = (e) => {
    if (e.target.name == "search") {
      filter.page = 1;
      setSelectedPage(1);
      setSearchFlag(true);
    }
    console.log(e.target.name, e.target.value);
    filter[e.target.name] = e.target.value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  const fetchExpertise = async () => {
    try {
      listExpertUsers({ userTypeFilter: 1 }).then((response) =>
        // console.log("response",response?.data)
        setExpertUsers(response?.data)
      );
      const data = await expertiseList(filter);
      const listData = data?.data || [];
      const temp = listData?.map((element) => {
        return { ...element, assignedUserImages: extractUrls(element) };
      });
      setExpertiseListData(temp);
      console.log("expertise11111", temp);
      setTotalResults(data?.totalResult || 0);
    } catch (error) {
      console.error("Error fetching invitees:", error);
      showAlert({
        title: "Expertise Module",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      console.log('Performing search for:', debouncedSearchTerm);
      // In a real application, you would make an API call here
      // fetchUsers();
      fetchExpertise();
      setSearchFlag(false);
    } else {
      console.log('Search term cleared.');
    }
  }, [debouncedSearchTerm]);

  const BeadcrumbItems = [{ label: "Expertise Areas", active: true }];
  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7">
          <CustomBreadcrumb items={BeadcrumbItems} />
          <PageTitle title="Expertise Areas" />
        </Col>
        <Col lg="5" className="text-end">
          <Button
            as="button"
            variant="primary"
            className="btn btn-md d-inline-flex align-items-center justify-content-end gap-1"
            onClick={() => rowHandler({ date: new Date() })}
          >
            <Image src="/images/plus-white.svg" alt="Plus White Icon" />
            Add Expertise
          </Button>
        </Col>
      </Row>
      <MainWrapper>
        <CardWrapper>
          <Row className="align-items-center gy-4 gy-xxl-0 mb-4">
            <Col xxl="9">
              <h2 className="fs-5 fw-semibold text-gray-800 mb-0">
                All Expertise Areas
              </h2>
            </Col>
            <Col xxl="3" xl="8" className="text-end">
              <input
                type="text"
                name="search"
                onChange={changeFilterCriteria}
                className="form-control form-control-search"
                aria-label="Search Input"
                placeholder="Search here.."
                autoComplete="off"
              />
            </Col>
          </Row>
          <DataTable>
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={index} className="cursor-pointer">
                    <div className="d-flex align-items-center">
                      {col.label}
                    </div>
                  </th>
                ))}
                <th width="8%">Action</th>
              </tr>
            </thead>
            <tbody>
              {console.log("expertiseListData", expertiseListData)}
              {expertiseListData?.length > 0 ? (
                expertiseListData?.map((element, ndex) => {
                  return (
                    <tr onClick={() => rowHandler(element)}
                    >
                      {
                        <td className={selectedItem?.id === element?.id && 'bg-gray-50'}>
                          <div className="fw-semibold d-flex align-items-center gap-2">
                            {element.images && element.images[0] ? (
                              <ImagePreviewLightbox
                                className="user-avtar user-avtar-32"
                                src={element.images[0]}
                              >
                                <Image
                                  src={element.images[0]}
                                  width="32"
                                  height="32"
                                  roundedCircle
                                  alt="Expertise Logo"
                                />{" "}
                              </ImagePreviewLightbox>
                            ) : (
                              <div className="user-avtar user-avtar-32 bg-blue-600">{element?.name.charAt(0)}</div>
                            )}
                            {element?.name}
                          </div>
                        </td>
                      }
                      {
                        <td className={selectedItem?.id === element?.id && 'bg-gray-50'}>
                          {(element?.children?.length == 0) && "NA" || <div className="tags">
                            {element?.children?.map((subElem, index) => {
                              if (index < subExpertiseToShow) {
                                return (
                                  <span key={index} className="tag">
                                    {subElem?.name}
                                  </span>
                                );
                              } else {
                                return null;
                              }
                            })}
                            {element?.children?.length > subExpertiseToShow && (
                              <span className="tag more">
                                +
                                {element?.children?.length - subExpertiseToShow}
                              </span>
                            )}
                          </div>}

                        </td>
                      }
                      {
                        <td className={selectedItem?.id === element?.id && 'bg-gray-50'}>
                          <div className="user-group">
                            {element?.assignedUserImages
                              ?.slice(0, 5)
                              .map((img, index) => (
                                <div className="user-group-item" key={index}>
                                  <ImagePreviewLightbox className="user-avtar user-avtar-32" src={img}>
                                    <Image
                                      src={img}
                                      width="32"
                                      height="32"
                                      roundedCircle
                                      alt="User Profile"
                                    />
                                  </ImagePreviewLightbox>
                                </div>
                              ))}
                            {element?.assignedUserImages?.length > 5 && (
                              <div className="user-group-item">
                                +{element.assignedUserImages.length - 5}
                              </div>
                            )}
                          </div>
                        </td>
                      }
                      {
                        <td className={selectedItem?.id === element?.id && 'bg-gray-50'}>
                          <div className="column-action-btn d-flex alig-items-center justify-content-center gap-2">
                            <button
                              type="button"
                              className="btn btn-icon"
                              aria-label="Edit Item"
                            >
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9797 5.5108L14.4891 2.01939C14.344 1.87423 14.1717 1.75908 13.9821 1.68052C13.7925 1.60196 13.5892 1.56152 13.384 1.56152C13.1787 1.56152 12.9755 1.60196 12.7859 1.68052C12.5963 1.75908 12.424 1.87423 12.2789 2.01939L2.64532 11.6538C2.4997 11.7984 2.38424 11.9706 2.30565 12.1602C2.22707 12.3498 2.18691 12.5532 2.18751 12.7585V16.2499C2.18751 16.6643 2.35213 17.0617 2.64515 17.3547C2.93818 17.6477 3.33561 17.8124 3.75001 17.8124H7.24141C7.44668 17.8129 7.65001 17.7727 7.83963 17.6942C8.02926 17.6156 8.2014 17.5001 8.3461 17.3545L17.9797 7.72017C18.2726 7.42716 18.4372 7.02981 18.4372 6.61549C18.4372 6.20117 18.2726 5.80381 17.9797 5.5108ZM7.10938 15.9374H4.06251V12.8905L10.625 6.32799L13.6719 9.37486L7.10938 15.9374ZM15 8.04674L11.9531 4.99986L13.3859 3.56705L16.4328 6.61392L15 8.04674Z" fill="#334155"></path></svg>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon"
                              aria-label="Delete Item"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowModal(element?.id);
                              }}
                            >
                              <Image
                                src="/images/trash.svg"
                                width={20}
                                height={20}
                                alt="Trash Red Icon"
                              />
                            </button>
                          </div>
                        </td>
                      }
                    </tr>
                  );
                })
              ) : (
                <tr className="default-pointer">
                  <td
                    colSpan={columns.length + 1}
                    className="fw-semibold text-center"
                  >
                    {expertiseListData == null
                      ? "Loading..."
                      : "No Data Available"}
                  </td>
                </tr>
              )}
            </tbody>
          </DataTable>
          <TablePagination
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            totalResults={totalResults}
            resultsPerPage={10}
          />
        </CardWrapper>
        <ExpertiseDetailsPanel
          item={selectedItem}
          setSelectedItem={setSelectedItem}
          isOpen={!!selectedItem}
          expertUsers={expertUsers}
          setShowModal={setShowModal}
          fetchExpertise={fetchExpertise}
          date={new Date()}
          deleteExpertiseFunc={deleteExpertiseFunc}
          appendExpertiseList={appendExpertiseList}
          onClose={() => setSelectedItem(null)}
        />
      </MainWrapper>

      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(null)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this expertise?
            </h2>
            <p className="fs-5 text-gray-500 fw-normal mb-0">
              Any sub expertise created or assigned experts will be removed.
            </p>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                onClick={(e) => deleteExpertiseFunc(showModal)}
                className="btn w-100 mt-5"
              >
                Delete Expertise
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(null)}
              >
                Nope, Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Routing;
